import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Grid2"
import { Button } from "@mui/material"
import { findLocation, useLocations } from "../../ReactQuery/QueryLocations"
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"
import { useSnackbar } from "notistack"

export default function CurrentLocationModal({
    open,
    closeModal,
    serviceOrderId,
    currentLocation
}) {
    const { enqueueSnackbar } = useSnackbar();
    const { data: locations, } = useLocations();
    const [selectedLocation, setSelectedLocation] = React.useState(findLocation(locations, currentLocation))
    const [saving, setSaving] = React.useState(false)

    const submit = (e) => {
        e.preventDefault();
        setSaving(true)
        const body = {
            location_id: selectedLocation.id
        }
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrderId}/update_current_location`, body).then((serviceOrder) => {
            enqueueSnackbar('Successfully updated current location', { variant: 'success' })
            setSaving(false)
            closeModal(serviceOrder.data.data)
        }).catch((error) => {
            console.log(error);
            enqueueSnackbar(`Failed to update current location: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
            setSaving(false)
        }))
    }

    React.useEffect(() => {
        setSelectedLocation(findLocation(locations, currentLocation))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLocation])

    React.useEffect(() => {
        if (selectedLocation === undefined) {
            setSelectedLocation(findLocation(locations, currentLocation))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locations])

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='md'
            >
                <LoadingBackdropIndeterminate
                    open={saving}
                    text={"Updating Current Location"}
                />
                <form onSubmit={submit}>
                    <DialogTitle>
                        <span style={{ "paddingRight": "24px" }}>Move To Location</span>
                        <IconButton
                            aria-label="close"
                            onClick={() => closeModal(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Box sx={{ pt: 1 }}>
                            <FormControl fullWidth>
                                <InputLabel id="select-modal-select-label">Location</InputLabel>
                                <Select
                                    labelId="select-modal-select-label"
                                    id="select-modal-select"
                                    value={selectedLocation?.id}
                                    label="Location"
                                    onChange={(e) => setSelectedLocation(findLocation(locations, e.target.value))}
                                >
                                    {locations.map((location) =>
                                        <MenuItem key={location.id} value={location.id}>{location.name}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                            <Grid xs="auto">
                            </Grid>
                            <Grid xs="auto">
                                <Button variant="contained" type="submit" disabled={selectedLocation === undefined || selectedLocation.id === currentLocation}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    )
}
